import { type ReactNode } from 'react';

export type WrapperProps = {
  children: ReactNode;
};

export function Wrapper(props: WrapperProps) {
  return <>{props.children}</>;
}
